<template>
  <div :class="['share-content actor', external && 'external', fileItem && fileItem.type, isFooterHide && 'fold']">
    <template v-if="external">
      <preview-view
        v-if="fileItem && fileItem.type === 'file'"
        :show="true"
        :shareTypeFile="true"
        :fileItem="fileItem"
        :permSave="canSave"
        @trigger-fold="handTriggerFold"
        :uniqueName="uniqueName"
        @toggle-save="toggleSave"
      />
      <file-view
        v-else-if="fileItem && (fileItem.type === 'folder' || fileItem.type === 'vfolder')"
        :class="{ 'footer-show': hideFileHeader && !isFooterHide }"
        scenario="share"
        :isExternalShare="true"
        :permSave="canSave"
        :hideFileHeader="hideFileHeader"
        :isMoreShare="isMoreShare"
        :uniqueName="uniqueName"
        :fileListData="fileListData"
        :process="process"
      />
      <share-footer
        v-show="hideFileHeader && !isFooterHide"
        :permDownload="permDownload"
        :permEdit="permEdit"
        :permSave="canSave"
        :fileType="fileItem && fileItem.type"
        @toggle-save="toggleSave"
        @toggle-download="handleDownload"
        @toggle-onlineedit="handleOnlineedit"
      />
      <a v-if="showComplaintBtn" class="complaint-btn" :href="complaintUrl"><i class="iconfont icon-unverification"></i></a>
    </template>
    <template v-else>
      <div class="thumb-icon">
        <thumb-icon
          :type="fileItem.type"
          :name="fileItem.name"
          :thumbnail="fileItem.thumbnail"
          :space="fileItem.space"
          :typeIcon="fileItem.type === 'folder' ? 'folder' : fileItem.type_icon"
        />
      </div>
      <div class="file-name">{{fileItem.name}}</div>
      <div class="share-actions">
        <button v-if="canSave" class="btn" @click="toggleSave">{{$t('base.save')}}</button>
        <button v-if="fileItem.type === 'folder'" class="btn" @click="visitFolder('share')">{{$t('base.open')}}</button>
        <button v-else-if="fileItem.type === 'file'" class="btn" @click="previewFile('share')">{{$t('base.preview')}}</button>
      </div>
      <div
        v-if="process.item_is_accessible_without_shared"
        class="visit-folder"
        v-html="$t(process.item && process.item.type === 'file' ? 'message.share.visitFile' : 'message.share.visitFolder')"
        @click="process.item && process.item.type === 'file' ? previewFile() : visitFolder()"
      />
    </template>
  </div>
</template>
<script>
import PreviewView from '../preview/PreviewView'
import FileView from '../file/FileView'
import ShareFooter from './ShareFooter'
import fileActions from '@/utils/fileActions'
import config from '@/config'
import ajax from '@/utils/ajax'
import { GET_SHARE_LINK_PASSWORD } from '@/config/api'

export default {
  name: 'ShareContent',
  components: {
    PreviewView,
    FileView,
    ShareFooter
  },
  props: {
    external: Boolean,
    process: Object,
    fileItem: Object,
    hideFileHeader: Boolean,
    isMoreShare: Boolean,
    uniqueName: String,
    fileListData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isFooterHide: false
    }
  },
  computed: {
    permDownload () {
      return !!(this.fileItem && this.fileItem.permissions && this.fileItem.permissions.includes('item_download'))
    },
    permSave () {
      return this.permDownload && !this.process.share_link.is_open_share_receiver
    },
    permEdit () {
      return this.fileItem && this.fileItem.is_share_wps_edit && this.fileItem.type === 'file'
    },
    showComplaintBtn () {
      // 个性化企业和文件夹里面不显示举报按钮
      return !config.is_custom_product && this.hideFileHeader && !this.isFooterHide && config.viewConfig.isComplainEnabled
    },
    complaintUrl () {
      return config.requestUrl + '/home/complaint?sharedata=' + `/share/${this.process.share_link.unique_name}`
    },
    canSave () {
      if (this.process) {
        return this.process.can_save && !this.process.share_link.is_open_share_receiver
      }
      return false
    }
  },
  methods: {
    visitFolder (scenario) {
      const {id} = this.fileItem
      const query = scenario === 'share' ? {scenario, unique_name: this.process.share_link.unique_name} : {}
      this.$router.push({path: `/files/folder/${id}`, query})
    },
    previewFile (scenario) {
      this.toggleQuery('preview', { file_id: this.fileItem.id, scenario })
    },
    toggleSave () {
      this.$emit('toggle-save')
    },
    handleDownload () {
      const extParams = {
        scenario: 'share',
        shareToken: this.process.share_link.unique_name
      }
      ajax({
        url: GET_SHARE_LINK_PASSWORD,
        data: { unique_name: this.process.share_link.unique_name }
      }).then(result => {
        if (result && result.success) {
          fileActions.downloadFile(this.fileItem, {...extParams, password: result.pass})
        }
      })
    },
    handleOnlineedit () {
      const file = this.fileItem || {}
      this.toggleQuery('preview', { wps_edit: true, file_id: file ? file.id : undefined, unique_name: this.process.share_link.unique_name })
    },
    handTriggerFold (fold) {
      // this.isFooterHide = fold
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.share-content.actor {
  background: #fff;
  padding: 30px 15px;
  text-align: center;

  &.external {
    background: transparent;
    text-align: left;
    padding: 0;
    position: relative;
    padding-bottom: 50px;

    &.folder {
      background-color: #eff2f6;
    }

    &.fold {
      /* padding-bottom: 0; */
    }
  }

  & .type-icon {
    font-size: 60px;
  }

  & .file-name {
    margin: 18px 0;
    word-wrap: break-word;
  }

  & .btn {
    background: #fff;
    border: 1px solid var(--sepLineColor);
    box-sizing: border-box;
    color: var(--primaryText);
    display: inline-block;
    height: 35px;
    line-height: 35px;
    margin-bottom: 5px;

    & + .btn {
      margin-left: 5px;
    }
  }

  & .visit-folder {
    margin-top: 20px;
    font-size: 14px;
    color: var(--secondlyText);
  }

  & .share-item img {
    width: 64px;
    height: 64px;
  }

  & .file-list {
    height: 100%;
  }

  & .share-footer {
    position: fixed;
    width: 100%;
    bottom: 0;
  }

  & .complaint-btn {
    position: fixed;
    z-index: 1;
    right: 10px;
    bottom: 50px;
    color: #b2b7ca;

    & i {
      font-size: 24px;
    }
  }
}
</style>
